import { render } from "./DatatableType.vue?vue&type=template&id=0002401c"
import script from "./DatatableType.vue?vue&type=script&lang=js"
export * from "./DatatableType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__